module.exports = __webpack_public_path__ + "img/image-gif.1f504b0a.png";